import { WritingsLineToDisplay } from "../routes/office/company/writings/Writings"

export function sortWritingsByArchiveId(
  writingsLines: WritingsLineToDisplay[],
  asc: boolean
): WritingsLineToDisplay[] {
  let sortedLines = []
  const pending = writingsLines.find((line) => line.status === "PENDING")
  if (pending) {
    sortedLines.push(pending)
  }

  const readyForArchive = writingsLines.find(
    (line) => line.status === "READY_FOR_ARCHIVE"
  )
  if (readyForArchive) {
    sortedLines.push(readyForArchive)
  }

  const created = writingsLines.filter((line) => line.status === "CREATED")
  if (created) {
    sortedLines.push(...created)
  }

  const linesWithoutTopThree = writingsLines.filter(
    (line) => !["PENDING", "READY_FOR_ARCHIVE", "CREATED"].includes(line.status)
  )

  sortedLines.push(...sortWritingsById(asc, linesWithoutTopThree))
  return sortedLines
}

export const sortWritingsById = (
  asc: boolean,
  writingsLines: WritingsLineToDisplay[]
): WritingsLineToDisplay[] => {
  return writingsLines.sort((a, b) =>
    asc
      ? (a?.archiveId || 0) - (b?.archiveId || 0)
      : (b?.archiveId || 0) - (a?.archiveId || 0)
  )
}

export const sortWritingsByProgress = (
  writingsLines: WritingsLineToDisplay[],
  asc: boolean
) => {
  let sortedLines = writingsLines.sort((a, b) =>
    asc ? a.progress - b.progress : b.progress - a.progress
  )
  return sortedLines
}

export const sortWritingsByEmail = (
  writingsLines: WritingsLineToDisplay[],
  asc: boolean
) => {
  let sortedLines = []
  const linesWithoutUser = writingsLines.filter((lines) => !lines.downloadUser)

  const LinesWithUser = writingsLines
    .filter((lines) => lines.downloadUser)
    .sort((a, b) =>
      asc
        ? String(a.downloadUser).localeCompare(String(b.downloadUser))
        : String(b.downloadUser).localeCompare(String(a.downloadUser))
    )

  sortedLines.push(...linesWithoutUser)
  sortedLines.push(...LinesWithUser)

  return sortedLines
}

export const sortWritingsByDate = (
  writingsLines: WritingsLineToDisplay[],
  asc: boolean
) => {
  let sortedLines = []
  const linesWithoutDate = writingsLines.filter((line) => !line.downloadDate)

  const linesWithDate = writingsLines
    .filter((line) => line.downloadDate)
    .sort((a, b) =>
      asc
        ? +new Date(String(a.downloadDate)) - +new Date(String(b.downloadDate))
        : +new Date(String(b.downloadDate)) - +new Date(String(a.downloadDate))
    )

  sortedLines.push(...linesWithoutDate)
  sortedLines.push(...linesWithDate)

  return sortedLines
}

export const sortWritingArchiveDownloadByDate = (
  allEvents: {
    email: string
    created_at: string
  }[]
) => {
  return [
    ...allEvents.sort(
      (a, b) => +new Date(b.created_at) - +new Date(a.created_at)
    ),
  ]
}
